var CalculatorTracking = {};

CalculatorTracking.trackYearChange = function(
  eventType,
  currentYear,
  isCurrentPeriod
) {
  var calendarPeriod = isCurrentPeriod ? 'thisYear' : 'previousYears';
  window.dataLayer.push({
    calculatorCalendarPeriod: calendarPeriod,
    calculatorCalendarState: eventType,
    event: 'changeCalculatorPeriod'
  });
};

CalculatorTracking.trackCategoryExpanded = function(category, state) {
  window.dataLayer.push({
    calculatorCategory: category,
    calculatorCategoryState: state,
    event: 'categoryExpand'
  });
};

CalculatorTracking.trackCategoryFilter = function(category, filter) {
  filter = parseInt(filter, 10);
  if (filter === 1) {
    window.dataLayer.push({
      calculatorCategoryFilter: category,
      calculatorCategoryState: 'Anbefalte kurs',
      event: 'categoryFilter'
    });
  } else if (filter === 2) {
    window.dataLayer.push({
      calculatorCategoryFilter: category,
      calculatorCategoryState: 'Påmeldte kurs/historikk',
      event: 'categoryFilter'
    });
  } else {
    /* NOTHING TODO HERE */
  }
};

CalculatorTracking.trackCourseExpanded = function(
  course,
  state,
  page,
  position
) {
  if (state === 'expand') {
    window.regnskapnorge.analytics.productViewed(course.CartObject);
  }
  window.dataLayer.push({
    courseListPageNumber: page,
    courseListPosition: position,
    courseExpandState: state,
    event: 'courseExpand'
  });
};

CalculatorTracking.trackCoursesPagination = function(
  category,
  currentPage,
  state
) {
  window.dataLayer.push({
    coursePaginationCategory: category,
    coursePaginationCurrentPage: currentPage,
    // 'coursePaginationState': state,
    event: 'calculatorCourses' + state
  });
};

CalculatorTracking.trackExtendedPages = function(type, action, state) {
  window.dataLayer.push({
    extendedPageType: type,
    extendedApiVersion: action,
    extendedState: state,
    event: 'expandExtended'
  });
};

CalculatorTracking.trackCloseExtendedPages = function(type, action) {
  window.dataLayer.push({
    extendedPageType: type,
    extendedApiVersion: action,
    event: 'closeExtended'
  });
};

// expanded-course: virtuell page

CalculatorTracking.trackCourseList = function(
  listName,
  courseList,
  page,
  itemsPerPage
) {
  var impressionList = [];
  for (var i = 0; i < courseList.length; i++) {
    var course = courseList[i].CartObject;
    var hours = 0;
    if (course.AuthorizationCredits) {
      for (var j = 0; j < course.AuthorizationCredits.length; j++) {
        hours += course.AuthorizationCredits[j].Hours;
      }
    }

    var impression = {
      name: course.Heading,
      id: course.Id,
      price: course.PriceNonMember,
      variant: course.EventTypeText,
      metric1: hours * 60 * 60,
      dimension1: course.City,
      position: i + page * itemsPerPage,
      list: 'Kurskalkulator - ' + listName + ' Side=' + (page + 1)
    };

    impressionList.push(impression);
  }

  window.dataLayer.push({
    ecommerce: {
      impressions: impressionList
    },
    event: 'courseCalculatorProductsViewed'
  });
};

module.exports = CalculatorTracking;
